<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useSkeleton } from '@/modules/core/composables/useSkeleton'
import IndividualLayout from '@/modules/investing/components/individuals/individual-layout.vue'
import NoteTimeline from '@/modules/investing/components/notes/note-timeline.vue'
import { useNoteStore } from '@/modules/investing/stores/note-store'
import { useIndividualStore } from '@/modules/investing/stores/better-individual-store'

const noteStore = useNoteStore()
const individualStore = useIndividualStore()

const { individual_id, slug } = useRoute().params as { individual_id: string; slug: string }

const { skeleton, hideSkeleton, showSkeleton } = useSkeleton()

onMounted(async () => {
  showSkeleton()
  await individualStore.fetchIndividual(individual_id, { slug })
  await noteStore.fetchNotes('investors', individual_id, { slug })
  hideSkeleton()
})
</script>

<template>
  <IndividualLayout selectedTab="notes">
    <div v-if="skeleton" class="py-8 text-center text-sm text-gray-500">Loading...</div>
    <NoteTimeline v-else commentableType="investors" :commentableId="individual_id" permission="admins" />
  </IndividualLayout>
</template>
